var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-maintenance"},[_c('img',{attrs:{"src":require("../assets/img/system.png"),"alt":""}}),_c('p',[_vm._v("系统维护中...")])])
}]

export { render, staticRenderFns }